import { render, staticRenderFns } from "./customer-coordinate.vue?vue&type=template&id=60334050&scoped=true&"
import script from "./customer-coordinate.vue?vue&type=script&lang=js&"
export * from "./customer-coordinate.vue?vue&type=script&lang=js&"
import style0 from "./customer-coordinate.vue?vue&type=style&index=0&id=60334050&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60334050",
  null
  
)

export default component.exports